<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit">
        <ContentOrLoading>
            <b-row v-if="!loading">
                <b-col cols="12">
                    <FormInput label="Nombre:" type="text" rules="required" name="nombre" v-model="plantillaLocal.nombre" />
                </b-col>
                <b-col cols="12">
                    <FormInput label="Descripción:" type="text" rules="required" name="descripcion" v-model="plantillaLocal.descripcion" />
                </b-col>
                <b-col cols="12" class="mt-2 text-right">
                    <button id="continuar" class="button" type="submit" :disabled="loading">
                        <span>Continuar</span>
                    </button>
                </b-col>
            </b-row>
        </ContentOrLoading>
    </ValidationObserver>
</template>

<script>

    export default {
        props: {
            loading: {
                type: Boolean,
                default: false
            },
            plantilla: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                plantillaLocal: { ...this.plantilla }
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();

                if (isValid) {
                    this.$emit('update:plantilla', this.plantillaLocal);
                    this.$emit('finalizarPasoUno');
                }
            }
        }
    }
</script>